// @flow

import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import RestClient from 'frontend_core/dist/rest/client'
import { actions as favoriteActions } from 'redux/modules/favorite'
import { setUIState, containerIds } from 'redux/modules/ui'
import FavoriteSelectModal from 'components/organisms/FavoriteSelectModal'
import ScrollControlView from 'components/atoms/ScrollControlView'

import FavoriteSelectModalUseCase, {
  type FavoriteSelectModalUsecaseType,
} from './usecase'

import { isNullOrUndefined } from 'util'
import type { User as UserType } from 'types/user'

import graphql from './graphql'

type PropTypes = {
  currentUser: UserType,
  roomId: string,
  data: Object,
  ui: {
    isShowingFavoriteSelectModal: boolean,
    isOpenFavoriteSelectModal: boolean,
    openInputFavoriteName: boolean,
    inputFavoriteListName: string,
  },
  favorite: {
    isSuccessFetchFavoriteList: boolean,
    isEmpty: boolean,
    registeredFavoriteLists: Array<{
      id: string,
    }>,
    favoriteList: Array<{
      id: number,
      name: string,
      thumbnail: string,
    }>,
    failedCreateFavoriteListMessage: string,
  },
  usecase: FavoriteSelectModalUsecaseType,
}

class FavoriteSelectModalContainer extends Component<PropTypes> {
  componentDidMount() {
    const { usecase } = this.props
    usecase.initialize()
  }

  componentWillReceiveProps(nextProps) {
    const { data: curData, usecase } = this.props
    const { data: nextData } = nextProps

    if (JSON.stringify(curData.room) !== JSON.stringify(nextData.room)) {
      usecase.setRegisteredFavoriteLists(
        nextData.room.registeredFavoriteLists.results,
      )
    }
  }

  restClient: RestClient

  favoriteListProps = () => {
    const { favorite } = this.props
    if (favorite.isSuccessFetchFavoriteList) {
      return favorite.registeredFavoriteLists.map((registeredFav: Object) => {
        return favorite.favoriteList
          .map(v => v.id)
          .filter(
            favoriteId => parseInt(registeredFav.id, 10) === favoriteId,
          )[0]
      })
    }
  }

  addFavoriteToList = id => {
    const { roomId, usecase } = this.props
    usecase.addFavoriteToList(roomId, id)
  }

  removeFavoriteFromList = id => {
    const { roomId, usecase } = this.props
    usecase.removeFavoriteFromList(roomId, id)
  }

  render() {
    const { usecase, ui, favorite } = this.props

    const isOpenInputFavoriteName = isNullOrUndefined(ui.openInputFavoriteName)
      ? favorite.isEmpty && favorite.isSuccessFetchFavoriteList
      : ui.openInputFavoriteName

    return (
      <ScrollControlView isLock={ui.isShowingFavoriteSelectModal}>
        <FavoriteSelectModal
          show={ui.isShowingFavoriteSelectModal}
          loading={!favorite.isSuccessFetchFavoriteList}
          favoriteList={favorite.favoriteList}
          registeredFavoriteLists={this.favoriteListProps()}
          currentUser={this.props.currentUser}
          onClickClose={usecase.closeFavoriteList}
          openInputFavoriteName={isOpenInputFavoriteName}
          onChangeFavoriteListName={usecase.inputFavoriteListName}
          onClickOpenInputFavorite={usecase.openInputFavoriteName}
          onClickCloseFavoriteSelectModal={usecase.closeFavoriteList}
          onClickCloseInputFavorite={usecase.closeInputFavoriteName}
          onClickCreateFavoriteList={usecase.createFavoriteList}
          errorMessage={favorite.failedCreateFavoriteListMessage}
          onClickAddFavoriteList={this.addFavoriteToList}
          onClickRemoveFavoriteList={this.removeFavoriteFromList}
        />
      </ScrollControlView>
    )
  }
}

function mapStateToProps(state) {
  return {
    config: state.config,
    ui: state.ui,
    favorite: state.favorite,
  }
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...favoriteActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(graphql(FavoriteSelectModalUseCase(FavoriteSelectModalContainer)))



// WEBPACK FOOTER //
// ./src/containers/organisms/FavoriteSelectModal/index.jsx